import 'nprogress/nprogress.css' // progress bar style
import Vue from 'vue';
import Router from 'vue-router';
import NProgress from "nprogress";
import store from "../store";
import {Message} from "element-ui";

import Login from '../page/login'
import Dashboard from '../page/dashBoard'
import Home from '../page/home'

import otherImport from './import'

import order from './order/index'
import delivery from './delivery/index'
import system from './system/index'

import msg from './msg/index'
import purchase from './purchase/index'
import send from './send/index'
import bill from './bill/index'


Vue.use(Router);

const modules = [send, delivery,order,system,otherImport, msg, purchase, bill];

let routes = [];
let subroutes = [];

modules.map((module) => {
    for (let key in module) {
        subroutes = subroutes.concat(module[key]['routes']);
    }
});

subroutes.push({
    path: '/dashboard',
    component: Dashboard
});

routes.push({
    path: '/index',
    // name: 'showPage',
    component: Home,
    redirect: '/dashboard',
    children: subroutes
});
routes.push({
    path: '/login',
    name: 'login',
    component: Login
});
routes.push({
    path: '/',
    redirect: '/index'
});

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
};

// 添加路由守卫
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (window.sessionStorage.getItem('wh-access-token')) {
        let token = window.sessionStorage.getItem('wh-access-token');
        if (to.path === '/login') {
            next();
        } else {
            if (token !== '') {
                if (window.sessionStorage.getItem('wh-user')) {
                    next();
                } else {
                    store.dispatch('login/loadUser').then((res) => {
                        let data = res.data.data;
                        if (data) {
                            window.sessionStorage.setItem('wh-user', JSON.stringify(data));
                            var year = new Date().getFullYear();
                            if(!data.loginTime || data.loginTime !== (year + '')) {
                                Message({
                                    message: '请先同意本平台使用协议',
                                    type: 'error',
                                    duration: 3 * 1000
                                });
                                next('/login');
                            } else {
                                next();
                            }
                        } else {
                            next('/login');
                        }
                    });
                }
            } else {
                next('/login');
            }
        }
    }else{
        if (to.path === '/login') {
            next();
        }else{
            next('/login');
        }
    }
});

router.afterEach(() => {
    NProgress.done()
});

export default router;


